var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
import { useEntity } from '../../hooks/use-entity';
var cls = classNames('slice-spacer');
export var SliceSpacerDefaultProps = {
  units: 4
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 0;\n    ", "\n  "], ["\n    font-size: 0;\n    ", "\n  "])), function (_a) {
    var units = _a.units;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", ";\n    "], ["\n      height: ", ";\n    "])), theme.UNIT(units / 6));
  }),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var units = _a.units;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: ", ";\n    "], ["\n      height: ", ";\n    "])), theme.UNIT(units / 2));
  }),
  desktop: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var units = _a.units;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      height: ", ";\n    "], ["\n      height: ", ";\n    "])), theme.UNIT(units));
  })
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var SliceSpacer = function SliceSpacer(props) {
  var className = props.className,
      units = props.units;
  var entity = useEntity(props.entity);
  return React.createElement(My.Container, {
    units: units || 4,
    className: cls.name(className)
  });
};
SliceSpacer.defaultProps = SliceSpacerDefaultProps;
SliceSpacer.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;